let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("98lbG")).then(() => parcelRequire('1yKGc'));